export default __webpack_public_path__ + "static/media/cognito.5c8b1647.svg";